export const GETALL_PART_REQUEST = "GETALL_PART_REQUEST";
export const GETALL_PART_SUCCESS = "GETALL_PART_SUCCESS";
export const GETALL_PART_FAIL = "GETALL_PART_FAIL";

export const GETBYID_PART_REQUEST = "GETBYID_PART_REQUEST";
export const GETBYID_PART_SUCCESS = "GETBYID_PART_SUCCESS";
export const GETBYID_PART_FAIL = "GETBYID_PART_FAIL";

export const ADD_PART_REQUEST = 'ADD_PART_REQUEST';   
export const ADD_PART_SUCCESS = 'ADD_PART_SUCCESS';
export const ADD_PART_FAIL = 'ADD_PART_FAIL';

export const UPDATE_PART_REQUEST = 'UPDATE_PART_REQUEST';
export const UPDATE_PART_SUCCESS = 'UPDATE_PART_SUCCESS';
export const UPDATE_PART_FAIL = 'UPDATE_PART_FAIL';

export const DELETE_PART_REQUEST = 'DELETE_PART_REQUEST';
export const DELETE_PART_SUCCESS = 'DELETE_PART_SUCCESS';
export const DELETE_PART_FAIL = 'DELETE_PART_FAIL';